export default __webpack_public_path__ + "static/media/gallery_03.23f56bf3.jpg";